import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { getIsFieldRequired } from 'utils';

import { FIELD_RULES } from '@atlas/react-forms';
import { DateSelect } from '@atlas/ui';

import Field from 'common/Form/Field';

const DaypickerField = ({ field, onBlur, onChange, onFocus }) => {
  const { disabled, errors, label, rules, touched, value } = field;
  const error = touched && errors[0];
  const success = touched && !error;

  const needRule = rules.find(rule => rule.type === FIELD_RULES.MIN_AGE);
  const minAge = needRule ? Number(needRule.ruleOption) : 0;

  const isRequiredSymbol = useMemo(() => getIsFieldRequired(rules), [rules]);

  return (
    <Field options={field}>
      <DateSelect
        disabled={disabled}
        error={error}
        isRequiredSymbol={isRequiredSymbol}
        label={label}
        minValue={minAge}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        success={success}
        value={value}
      />
    </Field>
  );
};

DaypickerField.propTypes = {
  field: PropTypes.object.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
};

export default DaypickerField;
